import React, { useEffect } from 'react';
import useWs from '../../../../../contexts/websockets';

interface Props {
  next: () => void;
}

const BattleConnectingStage = ({ next }: Props) => {
  const { wsConnect, wsError, wsConnected } = useWs();

  useEffect(() => {
    wsConnect();
  }, []);

  useEffect(() => {
    if (wsConnected) next();
  }, [wsConnected]);

  if (wsError) return <h2>Connection error. Please refresh a page</h2>;

  return null;
};

export default BattleConnectingStage;
